import { useSidebarOpenState } from '@backstage/core-components';
import { CollapsedThemeToggle } from './CollapsedThemeToggle';
import { ExpandedThemeToggle } from './ExpandedThemeToggle';

export const ThemeToggle = () => {
  const { isOpen } = useSidebarOpenState();

  if (!isOpen) {
    return <CollapsedThemeToggle />;
  }

  return <ExpandedThemeToggle />;
};
